import {BrandsProductListMeta} from '@/src/(pages)/brands/ui/meta'

export {BrandsProductListMeta}
